// Shared PWA install controller. Captures the browser's `beforeinstallprompt`
// event once at startup so any component (top banner, sidebar button, etc.) can
// trigger an install at any time.
let deferredPrompt = null;

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    window.dispatchEvent(new Event("rca:installable"));
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    localStorage.setItem("rca_app_installed", "1");
    window.dispatchEvent(new Event("rca:installed"));
  });
}

export function canInstall() {
  return !!deferredPrompt;
}

export function isStandalone() {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

// Fires the native install prompt. Returns "accepted" | "dismissed" | "unavailable".
export async function promptInstall() {
  if (!deferredPrompt) return "unavailable";
  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  if (outcome === "accepted") {
    localStorage.setItem("rca_app_installed", "1");
    deferredPrompt = null;
    window.dispatchEvent(new Event("rca:installed"));
  }
  return outcome;
}
